import ArrowLink from "components/components/ArrowLink/ArrowLink";
import SwaggerSingleRow from "components/dataVisualization/dataPageComponents/SwaggerSingleRow/SwaggerSingleRow";
import {
  Endpoint,
  I014TagValue,
} from "models/apiDocumentation/apiDocumentationModels";
import React from "react";
import { getEndpointDataByPath } from "utils/apiDocumentationUtils";
import routeConstants from "utils/routeConstants";

import { SingleRowContainer } from "./style";

interface Props {
  linkSlug: string;
  getSwaggerSpec: (isNoSqlEndpoint: boolean) => string;
  apiEndpoints: Endpoint[];
}

const SingleEndpoint: React.FC<Props> = ({
  linkSlug,
  getSwaggerSpec,
  apiEndpoints,
}) => {
  const endpointData = getEndpointDataByPath(
    apiEndpoints,
    `/endpoint/${linkSlug}`
  );
  const isNoSqlEndpoint = endpointData?.tags.includes(I014TagValue) ?? false;

  return (
    <SingleRowContainer>
      <SwaggerSingleRow
        swaggerSpec={getSwaggerSpec(isNoSqlEndpoint)}
        endpointData={endpointData}
      />
      <ArrowLink
        to={`${routeConstants.apiDocs}/endpoint/${linkSlug}`}
        text="View in API documentation"
        isInternalDestination={true}
      />
    </SingleRowContainer>
  );
};

export default SingleEndpoint;
